<template>
  <div class="popup-wrapper">
    <div @click.self="close">
      <form @submit.prevent>
        <div class="popup-action" :class="{'hide-parent-popup': isChildPopupShown}">
          <div class="button button-submit">
            <div role="button" class="btn ga-search-qa-detail"
              @click.prevent.stop="group1.search"
            ><FontawesomeIcon :icon="['fal','search']" size="lg" class="icn mr4" />この条件で検索する
            </div>
          </div>
          <div class="button button-close">
            <button class="btn" @click="close">
              <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
            </button>
          </div>
        </div>
        <div class="popup-container">
          <div class="popup" style="padding-bottom:200px;">
            <div class="popup-title">
              <span class="popup-title-main">詳細検索</span>
              <span @click="group1.clearSearchCondition" class="popup-title-sup" role="button">検索条件をリセット</span>
            </div>
            <div class="popup-content">

              <p v-if="group1.isError" class="error-message mt16">入力内容に不備があるようです。下記メッセージ（赤文字）のご確認をお願いいたします。</p>

              <div class="popup-content-01 tab">
                <div class="tab-head">
                  <ul class="tab-label">
                    <li
                      role="button" 
                      @click="group1.changeTab1(1)"
                      :class="{'is-active': group1.tab1 === 1}"
                    >
                      キーワード検索
                    </li>
                    <li
                      role="button" 
                      @click="group1.changeTab1(2)"
                      :class="{'is-active': group1.tab1 === 2}"
                    >
                      AND / OR検索
                    </li>
                  </ul>
                </div>
                <div class="tab-container">
                  <div id="tab_cnt_01_01" class="tab-content"
                    v-if="group1.tab1 === 1"
                  >
                    <ul class="tab-content-list">
                      <li class="tab-content-list-item qa-search-detail01_01">
                        <p class="hdg04 mb12">検索キーワード（AND検索）</p>
                        <div class="formparts text mb20">
                          <input v-model="group1.keyword_search_text_input" type="text" maxlength="50" placeholder="キーワード（最大50文字）">
                        </div>
                        <p class="hdg04 mb12">除外キーワード（OR検索）</p>
                        <div class="formparts text">
                          <input v-model="group1.keyword_excluding_text" type="text" maxlength="50" placeholder="除外キーワード（最大50文字）">
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div id="tab_cnt_01_02" class="tab-content"
                    v-else-if="group1.tab1 === 2"
                  >
                    <ul class="tab-content-list">
                      <li class="tab-content-list-item qa-search-detail02_01">
                        <p class="hdg04">検索キーワード</p>
                        <div class="qa-container">
                          <div class="qa-content">

                            <template v-for="(item, index) in group1.andor_search_texts">
                              <div :key="'andor_search_texts_input_' + index" class="qa-content-item">
                                <div class="row">
                                  <div class="or"></div>
                                  <div class="formparts text">
                                    <input v-model="item.text1" type="text" maxlength="50" placeholder="キーワード">
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="or">OR</div>
                                  <div class="formparts text">
                                    <input v-model="item.text2" type="text" maxlength="50" placeholder="キーワード">
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="or">OR</div>
                                  <div class="formparts text">
                                    <input v-model="item.text3" type="text" maxlength="50" placeholder="キーワード">
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="or">OR</div>
                                  <div class="formparts text">
                                    <input v-model="item.text4" type="text" maxlength="50" placeholder="キーワード">
                                  </div>
                                </div>
                              </div>
                              <div :key="'andor_search_texts_and_' + index" v-if="index < group1.andor_search_texts.length - 1" class="and">AND</div>
                            </template>

                            <div class="more" role="button"
                              @click="group1.addSearchTextsRow"
                            >条件(AND)をプラスする＋</div>
                          </div>
                        </div>
                        <p class="hdg04">除外キーワード</p>
                        <div class="qa-container">
                          <div class="qa-content">

                            <template v-for="(item, index) in group1.andor_excluding_texts">
                              <div :key="'andor_excluding_texts_input_' + index" class="qa-content-item">
                                <div class="row">
                                  <div class="or"></div>
                                  <div class="formparts text">
                                    <input v-model="item.text1" type="text" maxlength="50" placeholder="除外キーワード">
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="or">OR</div>
                                  <div class="formparts text">
                                    <input v-model="item.text2" type="text" maxlength="50" placeholder="除外キーワード">
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="or">OR</div>
                                  <div class="formparts text">
                                    <input v-model="item.text3" type="text" maxlength="50" placeholder="除外キーワード">
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="or">OR</div>
                                  <div class="formparts text">
                                    <input v-model="item.text4" type="text" maxlength="50" placeholder="除外キーワード">
                                  </div>
                                </div>
                              </div>
                              <div :key="'andor_excluding_texts_and_' + index" v-if="index < group1.andor_excluding_texts.length - 1" class="and">AND</div>
                            </template>
                              <div class="more" role="button"
                                @click="group1.addExcludingTextsRow"
                                >条件(AND)をプラスする＋</div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div v-if="group1.tab1 === 1" class="formparts checkbox mb20 ml20">
                    <input type="checkbox" :id="'qa_search_detail_is_fuzzy_' + group1.parentName"
                      v-model.number="group1.is_fuzzy_input" 
                      :true-value="0"
                      :false-value="1"
                    >
                    <label :for="'qa_search_detail_is_fuzzy_' + group1.parentName">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                  <div v-if="group1.tab1 === 2" class="formparts checkbox mb20 ml20">
                    <input type="checkbox" :id="'qa_search_detail_andor_is_fuzzy_' + group1.parentName"
                      v-model.number="group1.andor_is_fuzzy_input" 
                      :true-value="0"
                      :false-value="1"
                    >
                    <label :for="'qa_search_detail_andor_is_fuzzy_' + group1.parentName">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
              </div>
              <div class="popup-content-02">
                <div class="box03">
                  <div class="box03-hdg">
                    <select class="select" v-model.number="group1.tab2">
                      <option value="1">パッケージ指定</option>
                      <option value="2">書籍を指定</option>
                      <option value="3">過去の世代を指定</option>
                    </select>
                    <FontawesomeIcon icon="angle-down" class="icn" />
                  </div>
                  <div class="box03-content">

                    <!-- パッケージを指定 -->
                    <template v-if="group1.tab2 === 1">
                      <p v-if="group1.choices_packages.length == 0">ライセンス契約がありません。</p>
                      <template v-else>
                        <p class="txt mb12">検索対象となるパッケージを選択してください。※年度指定との併用はできません。</p>
                        <div class="formparts textarea">
                          <textarea v-model="group1.packageNamesDisp" rows="5" readonly></textarea>
                        </div>
                        <div class="button-wrap">
                          <div class="button">
                            <button class="btn" type="button" name="button" @click="openSearchPackageList">選択</button>
                          </div>
                          <span v-if="group1.package_ids.length > 0" @click="group1.clearPackageChoices" class="txt-link" role="button">指定をクリア</span>
                        </div>
                      </template>
                    </template>

                    <!-- 書籍を指定 -->
                    <template v-else-if="group1.tab2 === 2">
                      <p class="txt mb12">検索対象となる書籍を選択してください。</p>
                      <div class="formparts textarea">
                        <textarea v-model="group1.selectedBookNamesDisp" rows="5" readonly></textarea>
                      </div>
                      <div class="button-wrap">
                        <div class="button">
                          <button class="btn" type="button" name="button" @click="openSearchBooks">選択</button>
                        </div>
                        <span v-if="group1.selectedBookList.length > 0" @click="group1.clearBookChoices" class="txt-link">指定をクリア</span>
                      </div>
                    </template>

                    <!-- 過去の世代を指定 -->
                    <template v-else-if="group1.tab2 === 3">
                      <p v-if="group1.choices_revisions_packages.length == 0">過去世代はありません。</p>
                      <template v-else>
                        <p class="txt mb12">検索したい世代を選択してください。</p>
                        <div class="formparts text">
                          <input v-model="group1.revisionNamesDisp" type="text" readonly>
                        </div>
                        <div class="button-wrap">
                          <div class="button">
                            <button class="btn" type="button" name="button" @click="openSearchlPastYearBookList">選択</button>
                          </div>
                          <span v-if="group1.package_id_revision_id !== ''" @click="group1.clearRevisionChoices" class="txt-link" role="button">指定をクリア</span>
                        </div>
                      </template>
                    </template>

                  </div>
                </div>
              </div>

              <div class="popup-content-03">
                <p class="hdg04 mb12 inline">
                  <span class="main">関連法令を指定</span>
                  <span class="sub" role="button"
                    @click="group1.isSingleSearch = !group1.isSingleSearch"
                  >
                    <template v-if="group1.isSingleSearch">複数法令を指定</template>
                    <template v-else>単一指定に戻す</template>
                  </span>
                </p>
                <template v-if="group1.isSingleSearch">
                  <div class="tab-content-list-item-section">
                    <div class="formparts text mb4">
                      <input v-model="group1.laws_single.title" type="text" placeholder="法令名">
                    </div>
                    <span class="txt">第</span>
                    <div class="formparts text inline" style="width:45px;">
                      <input v-model="group1.laws_single.article1" type="text" maxlength="4">
                    </div>
                    <span class="txt">条の</span>
                    <div class="formparts text inline" style="width:45px;">
                      <input v-model="group1.laws_single.article2" type="text" maxlength="4">
                    </div>
                    <span class="txt">の</span>
                    <div class="formparts text inline" style="width:45px;">
                      <input v-model="group1.laws_single.article3" type="text" maxlength="4">
                    </div>
                    <span class="txt">の</span>
                    <div class="formparts text inline" style="width:45px;">
                      <input v-model="group1.laws_single.article4" type="text" maxlength="4">
                    </div>
                  </div>
                  <p v-if="group1.error_laws_single" class="error-message">{{ group1.error_laws_single }}</p>
                </template>
                <template v-else>
                  <div class="mb16">
                    <div class="mb4">
                      <div class="formparts text mb4">
                        <input v-model="group1.laws_multi.group1.title" type="text" placeholder="法令名">
                      </div>
                      <span class="txt">第</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group1.article1" type="text" maxlength="4">
                      </div>
                      <span class="txt">条の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group1.article2" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group1.article3" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group1.article4" type="text" maxlength="4">
                      </div>
                    </div>
                    <div class="mb4">
                      <span class="txt">を参照し、</span>
                      <div class="formparts select inline" style="width:110px;"
                        v-click-outside="() => { state.isSelectboxVisibleOption = false }"
                        :class="{'is-visible-list': state.isSelectboxVisibleOption}"
                      >
                        <div @click="state.isSelectboxVisibleOption = !state.isSelectboxVisibleOption"
                          class="select-label" role="select">
                          <template v-if="group1.laws_multi.group1_ope === 'and'">かつ</template>
                          <template v-else-if="group1.laws_multi.group1_ope === 'or'">または</template>
                          <FontawesomeIcon :icon="state.isSelectboxVisibleOption ? 'angle-up' : 'angle-down'" class="icn" />
                        </div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option"><label><input type="radio" v-model="group1.laws_multi.group1_ope" value="and" @click="state.isSelectbox2VisibleOption = false; state.isSelectboxVisibleOption = false">かつ</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.laws_multi.group1_ope" value="or" @click="state.isSelectbox2VisibleOption = false; state.isSelectboxVisibleOption = false">または</label></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-if="group1.error_laws_multi_group1" class="error-message">{{ group1.error_laws_multi_group1 }}</p>
                  <div class="mb16">
                    <div class="mb4">
                      <div class="formparts text mb4">
                        <input v-model="group1.laws_multi.group2.title" type="text" placeholder="法令名">
                      </div>
                      <span class="txt">第</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group2.article1" type="text" maxlength="4">
                      </div>
                      <span class="txt">条の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group2.article2" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group2.article3" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group2.article4" type="text" maxlength="4">
                      </div>
                    </div>
                    <div class="mb4">
                      <span class="txt">を参照し、</span>
                      <div class="formparts select inline" style="width:110px;"
                        v-click-outside="() => { state.isSelectbox2VisibleOption = false }"
                        :class="{'is-visible-list': state.isSelectbox2VisibleOption}"
                      >
                        <div @click="state.isSelectbox2VisibleOption = !state.isSelectbox2VisibleOption"
                          class="select-label" role="select">
                          <template v-if="group1.laws_multi.group2_ope === 'and'">かつ</template>
                          <template v-else-if="group1.laws_multi.group2_ope === 'or'">または</template>
                          <FontawesomeIcon :icon="state.isSelectbox2VisibleOption ? 'angle-up' : 'angle-down'" class="icn" />
                        </div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option"><label><input type="radio" v-model="group1.laws_multi.group2_ope" value="and" @click="state.isSelectbox2VisibleOption = false; state.isSelectbox2VisibleOption = false">かつ</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.laws_multi.group2_ope" value="or" @click="state.isSelectbox2VisibleOption = false; state.isSelectbox2VisibleOption = false">または</label></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-if="group1.error_laws_multi_group2" class="error-message">{{ group1.error_laws_multi_group2 }}</p>

                  <div>
                    <div class="mb4">
                      <div class="formparts text mb4">
                        <input v-model="group1.laws_multi.group3.title" type="text" placeholder="法令名">
                      </div>
                      <span class="txt">第</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group3.from_article1" type="text" maxlength="4">
                      </div>
                      <span class="txt">条の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group3.from_article2" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group3.from_article3" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group3.from_article4" type="text" maxlength="4">
                      </div>
                    </div>
                    <p class="txt mb4">から</p>
                  </div>
                  <p v-if="group1.error_laws_multi_group3_from" class="error-message">{{ group1.error_laws_multi_group3_from }}</p>
                  <div>
                    <div class="mb4">
                      <span class="txt">第</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group3.to_article1" type="text" maxlength="4">
                      </div>
                      <span class="txt">条の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group3.to_article2" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group3.to_article3" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:45px;">
                        <input v-model="group1.laws_multi.group3.to_article4" type="text" maxlength="4">
                      </div>
                    </div>
                    <p class="txt mb4">を参照する</p>
                  </div>
                  <p v-if="group1.error_laws_multi_group3_to" class="error-message">{{ group1.error_laws_multi_group3_to }}</p>
                </template>
              </div>

              <div class="popup-content-04">
                <p class="hdg04 mb12">裁判情報を指定</p>
                <p class="txt mb12">検索対象となる裁判所を選択してください。</p>
                <div class="formparts text mb20">
                  <input v-model="group1.judgementCourtNamesDisp" type="text" readonly>
                </div>
                <div class="button-wrap">
                  <div class="button">
                    <span class="btn" role="button"
                      @click="openSearchCourt"
                    >選択
                    </span>
                  </div>
                  <span v-if="group1.judgement.court_names.length > 0" @click="group1.clearJudgementChoices" class="txt-link">指定をクリア</span>
                </div>
                <p class="hdg04 mb8 mt20">裁判年月日</p>
                <div class="qa-content mb20">
                  <div class="qa-content-item">
                    <div class="formparts select inline"
                      v-click-outside="() => { selectBox.isVisibleEraList = false }"
                      :class="{'is-visible-list': selectBox.isVisibleEraList}"
                    >
                      <div @click="selectBox.isVisibleEraList = !selectBox.isVisibleEraList"
                        class="select-label" role="select">{{ group1.disp_judgement_era }}<FontawesomeIcon :icon="selectBox.isVisibleEraList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                      <div class="select-option">
                        <ul class="select-option-list">
                          <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="">選択</label></li>
                          <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="令和">令和</label></li>
                          <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="平成">平成</label></li>
                          <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="昭和">昭和</label></li>
                          <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="大正">大正</label></li>
                          <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="明治">明治</label></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="qa-content-item">
                    <div class="formparts select inline"
                      v-click-outside="() => { selectBox.isVisibleYearList = false }"
                      :class="{'is-visible-list': selectBox.isVisibleYearList}"
                    >
                      <div @click="selectBox.isVisibleYearList = !selectBox.isVisibleYearList"
                        class="select-label" role="select">{{ group1.disp_judgement_year }}<FontawesomeIcon :icon="selectBox.isVisibleYearList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                      <div class="select-option">
                        <ul class="select-option-list">
                          <li  role="option">
                            <label><input type="radio" v-model.number="group1.judgement.year" @click="selectBox.isVisibleYearList = false" :value="0">選択</label>
                          </li>
                          <li v-for="n of group1.disp_judgement_last_year_of_era" :key="'judgement_year_' + n" role="option">
                            <label><input type="radio" v-model.number="group1.judgement.year" @click="selectBox.isVisibleYearList = false" :value="n">{{ (n == 1) ? '元' : n }}</label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="qa-content-item">
                    <span class="text">年</span>
                  </div>
                  <br>

                  <div class="qa-content-item">
                    <div class="formparts select inline"
                      v-click-outside="() => { selectBox.isVisibleMonthList = false }"
                      :class="{'is-visible-list': selectBox.isVisibleMonthList}"
                    >
                      <div @click="selectBox.isVisibleMonthList = !selectBox.isVisibleMonthList"
                        class="select-label" role="select">{{ group1.disp_judgement_month }}<FontawesomeIcon :icon="selectBox.isVisibleMonthList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                      <div class="select-option">
                        <ul class="select-option-list">
                          <li role="option">
                            <label><input type="radio" v-model.number="group1.judgement.month" @click="selectBox.isVisibleMonthList = false" :value="0">選択</label>
                          </li>
                          <li v-for="n of 12" :key="'judgement_month_' + n" role="option">
                            <label><input type="radio" v-model.number="group1.judgement.month" @click="selectBox.isVisibleMonthList = false" :value="n">{{n}}</label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="qa-content-item">
                    <span class="text">月</span>
                  </div>

                  <div class="qa-content-item">
                    <div class="formparts select inline"
                      v-click-outside="() => { selectBox.isVisibleMdayList = false }"
                      :class="{'is-visible-list': selectBox.isVisibleMdayList}"
                    >
                      <div @click="selectBox.isVisibleMdayList = !selectBox.isVisibleMdayList"
                        class="select-label" role="select">{{ group1.disp_judgement_mday }}<FontawesomeIcon :icon="selectBox.isVisibleMdayList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                      <div class="select-option">
                        <ul class="select-option-list">
                          <li role="option">
                            <label><input type="radio" v-model.number="group1.judgement.mday" @click="selectBox.isVisibleMdayList = false" :value="0">選択</label>
                          </li>
                          <li v-for="n of 31" :key="'judgement_mday_' + n" role="option">
                            <label><input type="radio" v-model.number="group1.judgement.mday" @click="selectBox.isVisibleMdayList = false" :value="n">{{n}}</label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="qa-content-item">
                    <span v-if="group1.judgement.restriction === 2" class="text">日から</span>
                    <span v-else class="text">日</span>
                  </div>
                  <br>

                  <div class="qa-content-item">
                    <div class="formparts select inline"
                      v-click-outside="() => { selectBox.isVisibleRestrictionList = false }"
                      :class="{'is-visible-list': selectBox.isVisibleRestrictionList}"
                    >
                      <div @click="selectBox.isVisibleRestrictionList = !selectBox.isVisibleRestrictionList"
                        class="select-label" role="select">{{ group1.disp_judgement_restriction }}<FontawesomeIcon :icon="selectBox.isVisibleRestrictionList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                      <div class="select-option">
                        <ul class="select-option-list">
                          <li role="option"><label><input type="radio" v-model.number="group1.judgement.restriction" @click="selectBox.isVisibleRestrictionList = false" value="1">日指定</label></li>
                          <li role="option"><label><input type="radio" v-model.number="group1.judgement.restriction" @click="selectBox.isVisibleRestrictionList = false" value="2">期間指定</label></li>
                          <li role="option"><label><input type="radio" v-model.number="group1.judgement.restriction" @click="selectBox.isVisibleRestrictionList = false" value="3">指定日以降</label></li>
                          <li role="option"><label><input type="radio" v-model.number="group1.judgement.restriction" @click="selectBox.isVisibleRestrictionList = false" value="4">指定日以前</label></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <p v-if="group1.error_judgement_date" class="error-message">{{ group1.error_judgement_date }}</p>
                </div>

                <template v-if="group1.judgement.restriction === 2">
                  <div class="qa-content mb20">
                    <div class="qa-content-item">
                      <div class="formparts select inline"
                        v-click-outside="() => { selectBox.isVisibleEndEraList = false }"
                        :class="{'is-visible-list': selectBox.isVisibleEndEraList}"
                      >
                        <div @click="selectBox.isVisibleEndEraList = !selectBox.isVisibleEndEraList"
                          class="select-label" role="select">{{ group1.disp_judgement_end_era }}<FontawesomeIcon :icon="selectBox.isVisibleEndEraList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="">選択</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="令和">令和</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="平成">平成</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="昭和">昭和</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="大正">大正</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="明治">明治</label></li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="qa-content-item">
                      <div class="formparts select inline"
                        v-click-outside="() => { selectBox.isVisibleEndYearList = false }"
                        :class="{'is-visible-list': selectBox.isVisibleEndYearList}"
                      >
                        <div @click="selectBox.isVisibleEndYearList = !selectBox.isVisibleEndYearList"
                          class="select-label" role="select">{{ group1.disp_judgement_end_year }}<FontawesomeIcon :icon="selectBox.isVisibleEndYearList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option">
                              <label><input type="radio" v-model.number="group1.judgement.end_year" @click="selectBox.isVisibleEndYearList = false" :value="0">選択</label>
                            </li>
                            <li v-for="n of group1.disp_judgement_end_last_year_of_era" :key="'judgement_end_year_' + n" role="option">
                              <label><input type="radio" v-model.number="group1.judgement.end_year" @click="selectBox.isVisibleEndYearList = false" :value="n">{{ (n === 1) ? '元' : n }}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="qa-content-item">
                      <span class="text">年</span>
                    </div>
                    <br>

                    <div class="qa-content-item">
                      <div class="formparts select inline"
                        v-click-outside="() => { selectBox.isVisibleEndMonthList = false }"
                        :class="{'is-visible-list': selectBox.isVisibleEndMonthList}"
                      >
                        <div @click="selectBox.isVisibleEndMonthList = !selectBox.isVisibleEndMonthList"
                          class="select-label" role="select">{{ group1.disp_judgement_end_month }}<FontawesomeIcon :icon="selectBox.isVisibleEndMonthList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option">
                              <label><input type="radio" v-model.number="group1.judgement.end_month" @click="selectBox.isVisibleEndMonthList = false" :value="0">選択</label>
                            </li>
                            <li v-for="n of 12" :key="'judgement_end_month_' + n" role="option">
                              <label><input type="radio" v-model.number="group1.judgement.end_month" @click="selectBox.isVisibleEndMonthList = false" :value="n">{{n}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="qa-content-item">
                      <span class="text">月</span>
                    </div>
                    <div class="qa-content-item">
                      <div class="formparts select inline"
                        v-click-outside="() => { selectBox.isVisibleEndMdayList = false }"
                        :class="{'is-visible-list': selectBox.isVisibleEndMdayList}"
                      >
                        <div @click="selectBox.isVisibleEndMdayList = !selectBox.isVisibleEndMdayList"
                          class="select-label" role="select">{{ group1.disp_judgement_end_mday }}<FontawesomeIcon :icon="selectBox.isVisibleEndMdayList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option">
                              <label><input type="radio" v-model.number="group1.judgement.end_mday" @click="selectBox.isVisibleEndMdayList = false" :value="0">選択</label>
                            </li>
                            <li v-for="n of 31" :key="'judgement_end_mday_' + n" role="option">
                              <label><input type="radio" v-model.number="group1.judgement.end_mday" @click="selectBox.isVisibleEndMdayList = false" :value="n">{{n}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="qa-content-item">
                      <span class="text">日まで</span>
                    </div>
                    <p v-if="group1.error_judgement_end_date" class="error-message">{{ group1.error_judgement_end_date }}</p>
                  </div>
                </template>

                <p class="hdg04 mb12">事件名</p>
                <div class="formparts text">
                  <input v-model="group1.case_name" type="text" placeholder="事件名">
                </div>
              </div>
            </div>
          </div>
        </div>          
      </form>
    </div>


    <!-- 書籍検索 -->
    <transition name="popup">
      <SPQASearchDetailBookList
        v-if="state.visibleSearchDetailBookList"
        :startLoading="state.visibleSearchDetailBookList"
        @closeSearchDetailBookList="state.visibleSearchDetailBookList = false"
      />
    </transition>

    <!-- パッケージ指定 -->
    <transition name="popup">
      <SPQASearchDetailPackageList
        v-if="state.visibleSearchPackageList"
        :parentGroup1="group1"
        @closeSearchDetailPackageList="state.visibleSearchPackageList = false"
      />
    </transition>

    <!-- 過去年度 -->
    <transition name="popup">
      <SPQASearchDetailPastYearBookList
        v-if="state.visibleSearchPastYearBookList"
        :parentGroup1="group1"
        @closeSearchDetailPastYearBookList="state.visibleSearchPastYearBookList = false"
      />
    </transition>

    <!-- 裁判所検索 -->
    <transition name="popup">
      <SPQASearchDetailCourtList
        v-if="state.visibleSearchDetailCourtList"
        :startLoading="state.visibleSearchDetailCourtList"
        @updateCourtNames="group1.updateCourtNames"
        @closeSearchDetailCourtList="state.visibleSearchDetailCourtList = false"
      />
    </transition>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import ClickOutside from 'vue-click-outside'
import SPQASearchDetailBookList from '@/components/sp/popup/SPQASearchDetailBookList.vue'
import SPQASearchDetailPastYearBookList from '@/components/sp/popup/SPQASearchDetailPastYearBookList.vue'
import SPQASearchDetailPackageList from '@/components/sp/popup/SPQASearchDetailPackageList.vue'
import SPQASearchDetailCourtList from '@/components/sp/popup/SPQASearchDetailCourtList.vue'

import * as logicQASearchDetail from '@/logic/qa/QASearchDetail'

export default defineComponent({
  components: {
    SPQASearchDetailBookList,
    SPQASearchDetailPastYearBookList,
    SPQASearchDetailPackageList,
    SPQASearchDetailCourtList
  },
  directives: {
    ClickOutside
  },
  props: {
    startLoading: {
      type: Boolean,
      required: true
    },
    // 呼び出し元の名前
    parentName: {
      type: String,
      required: true
    },
    // メニューから呼ばれた場合のその呼び出し元の名前
    parentNameOfMenu: {
      type: String,
      default: ''
    }
  },
  setup (props, context) {

    const group1 = logicQASearchDetail.getGroup(props, context)

    const state = reactive({
      isSelectboxVisibleOption: false,
      isSelectbox2VisibleOption: false,
      visibleSearchDetailBookList: false,
      visibleSearchPackageList: false,
      visibleSearchPastYearBookList: false,
      visibleSearchDetailCourtList: false
    })
    const selectBox = reactive({
      isVisibleEraList: false,
      isVisibleYearList: false,
      isVisibleMonthList: false,
      isVisibleMdayList: false,
      isVisibleEndEraList: false,
      isVisibleEndYearList: false,
      isVisibleEndMonthList: false,
      isVisibleEndMdayList: false,
      isVisibleRestrictionList: false
    })
    const close = () => {
      context.emit('closeSearchDetail')
    }
    const submit = () => {
      context.emit('closeSearchDetail')
    }

    const openSearchBooks = () => {
      state.visibleSearchDetailBookList = true
    }
    const openSearchPackageList = () => {
      state.visibleSearchPackageList = true
    }
    const openSearchlPastYearBookList = () => {
      state.visibleSearchPastYearBookList = true
    }
    const openSearchCourt = () => {
      state.visibleSearchDetailCourtList = true
    }

    /**
    * 子供のポップアップを表示しているか
    */
    const isChildPopupShown = computed(() => {
      return (
        state.visibleSearchDetailBookList || 
        state.visibleSearchPackageList || 
        state.visibleSearchPastYearBookList || 
        state.visibleSearchDetailCourtList
      )
    })

    const openSearchSign = () => {
      context.emit('openSearchSign')      
    }
    const tab = reactive({
      id: 1,
      changeTab(num) {
        this.id = num
      }
    })
   
    return {
      group1,
      selectBox,
      close,
      state,
      submit,
      openSearchCourt,
      openSearchBooks,
      openSearchSign,
      openSearchPackageList,
      openSearchlPastYearBookList,
      tab,
      isChildPopupShown
    }
  }
})
</script>

<style lang="scss" scoped>

.popup-content {
  padding: 0!important;
  .tab {
    &-label {
      li {
        width: 50%;
      }
    }
    &-content {
      &-list {
        list-style: none;
        &-item {
          padding: 20px;
          & + li {
            border-top: 1px solid $color-line;
          }
          & > .formparts:last-child {
            margin-bottom: 0;
          }
          &-section {

          }
        }
      }
    }
  }
  &-01 {

  }
  &-02 {
    background-color: $color-bg-paper;
    padding: 20px 20px 20px 0;
    .box03 {
      .select {
        position: relative;
        z-index: 1;
        width: 100%;
        color: $color-link;
      }
    }
  }
  &-03 {
    padding: 20px;
    .hdg04 {
      position: relative;
      padding-right: 130px;
      .sub {
        position: absolute;
        right: 0;
        top: 7px;
        color: $color-link;
        font-size: 1.4rem;
        font-weight: normal; 
      }
    }
    .txt {
      margin-right: 4px;
    }
    .formparts.inline {
      margin: 8px 4px 0 0;
    }
    .formparts.text input[type="number"] ,
    .formparts.text input[type="text"] {
      padding: 8px 5px;
    }
  }
  &-04 {
    padding: 20px;
    .qa-content {
      position: relative;
      color: $color-content;
    }
    .qa-content-item {
      display: inline-block;
      margin: 8px 8px 0 0;
      .title {
        display: inline-block;
      }
      .formparts {
        margin: 0;
        .select-label {
          padding-right: 25px;
          .icn {
            right: 10px;
            color: $color-content;
          }
        }
        .select-option-list {
          li {
            padding: 8px 15px;
            text-align: center;
          }
        }
      }
    }
    .fugo {
      position: absolute;
      right: 0;
    }
  }
}
.popup-title {
  position: relative;
  &-button {
    color: #fff;
    background-color: #0070D3;
    width: 460px;
    height: 48px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity .2s ease;
    &:hover {
      opacity: .7;
    }
    .icn {
      width: 20px;
    }
  }
  &-sup {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translate3d(0,-50%,0);
    color: $color-link;
    font-size: 1.2rem;
  }
}
.qa-content-border {
  border: none;
  height: 1px;
  background-color: $color-line;
  display: block;
  margin: 20px 0;
}
.button-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  .button {
    width: 180px;
  }
  .txt-link {
    color: $color-link;
    margin: 0 20px;
    white-space: nowrap;
  }
}
// .qa-search-detail01_02,
// .qa-search-detail02_02 {
//   background-color: $color-bg-paper;
//   padding-left: 0!important;
//   .box03 {
//     .select {
//       color: $color-link;
//     }
//   }
// }
// .qa-search-detail01_03,
// .qa-search-detail02_03 {
//   .button {
//     margin-left: auto;
//     margin-right: auto;
//   }
// }
// .qa-search-detail01_04,
// .qa-search-detail02_04 {
//   .hdg04 {
//     position: relative;
//     padding-right: 130px;
//     .sub {
//       position: absolute;
//       right: 0;
//       top: 7px;
//       color: $color-link;
//       font-size: 1.4rem;
//       font-weight: normal; 
//     }
//   }
//   .txt {
//     margin-right: 4px;
//   }
//   .formparts.inline {
//     margin: 8px 4px 0 0;
//   }
//   .formparts.text input[type="text"] {
//     padding: 8px 5px;
//   }
// }
// .qa-search-detail01_05,
// .qa-search-detail02_05 {
//   .button {
//     margin-left: auto;
//     margin-right: auto;
//   }
//   .qa-content {
//     position: relative;
//     color: $color-content;
//   }
//   .qa-content-item {
//     display: inline-block;
//     margin: 8px 8px 0 0;
//     .title {
//       display: inline-block;
//     }
//     .formparts {
//       margin: 0;
//       .select-label {
//         padding-right: 25px;
//         .icn {
//           right: 10px;
//           color: $color-content;
//         }
//       }
//     }
//   }
//   .fugo {
//     position: absolute;
//     right: 0;
//   }
// }
.qa-search-detail02_01 {
  padding-left: 0!important;
  .qa-container {
    border-top: 1px solid $color-line;
    border-right: 1px solid $color-line;
    border-bottom: 1px solid $color-line;
    border-radius: 0 8px 8px 0;
    padding: 20px 20px 20px 0;
    background-color: $color-bg-paper;
    & + .hdg04 {
      margin-top: 16px;
    }
  }
  .hdg04 {
    margin: 0 20px 16px;
  }
  .checkbox {
    margin: 0 0 0 16px;
  }
  .qa-content {
    &-item {
      background-color: #fff;
      padding: 20px;
      border-radius: 0 8px 8px 0;
    }
    .row {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      .or {
        width: 30px;
      }
      .formparts {
        width: calc(100% - 30px);
      }
    }
    .and,.or {
      color: $color-content;
      font-size: 1.4rem;
    }
    .and {
      padding: 20px;
      text-align: center;
    }
    .more {
      padding-top: 20px;
      color: $color-link;
      font-size: 1.4rem;
      text-align: center;
    }
  }
  // パターン２
  // .qa-content {
  //   width: 100%;
  //   td {
  //     display: block;
  //     text-align: center;
  //   }
  //   .formparts {
  //     margin-bottom: 0;
  //   }
  //   .txt-add {
  //     display: block;
  //     position: relative;
  //     z-index: 2;
  //     margin: 20px 0;
  //     .char {
  //       position: relative;
  //       z-index: 2;
  //       background-color: #fff;
  //       padding: 0 8px;
  //       display: inline-block;
  //     }
  //     &:after {
  //       content: '';
  //       position: absolute;
  //       z-index: 1;
  //       top: 50%;
  //       left: 0;
  //       transform: translate3d(0,-50%,0);
  //       display: block;
  //       height: 1px;
  //       width: 100%;
  //       background-color: $color-line;
  //     }
  //   }
  //   .add {
  //     color: $color-link;
  //     svg {
  //       margin-left: 4px;
  //     }
  //   }
  // }
}
.sp .menu .popup-wrapper:before {
  content: none !important;
}
</style>
